/** Реферальная ссылка сохраняется на этом устройстве до регистрации, не дольше 30 дней. */
const KEY = 'klichat.ref'
const SAVED_KEY = 'klichat.ref.saved'
const TTL = 30 * 24 * 60 * 60 * 1000
let memory: { code: string; expires: number } | null = null

/** Принимаем код либо полную ссылку; неизвестный формат не превращаем в приглашение. */
export function parseReferral(value: string): string {
  const raw = value.trim()
  if (/^[a-z0-9]{4,32}$/i.test(raw)) return raw.toLowerCase()
  try {
    const url = new URL(raw)
    if (!['http:', 'https:'].includes(url.protocol)) return ''
    const code = /^\/r\/([a-z0-9]{4,32})\/?$/i.exec(url.pathname)?.[1] ?? url.searchParams.get('ref') ?? ''
    return /^[a-z0-9]{4,32}$/i.test(code) ? code.toLowerCase() : ''
  } catch { return '' }
}

export function clearReferral(): void {
  memory = null
  try { localStorage.setItem(SAVED_KEY, 'null') } catch { /* хранилище недоступно */ }
  try { sessionStorage.removeItem(KEY) } catch { /* хранилище недоступно */ }
}

export function saveReferral(value: string): void {
  const code = parseReferral(value)
  if (!code) { clearReferral(); return }
  memory = { code, expires: Date.now() + TTL }
  try { localStorage.setItem(SAVED_KEY, JSON.stringify(memory)) } catch { /* запасной путь ниже */ }
  try { sessionStorage.setItem(KEY, JSON.stringify(memory)) } catch { /* в этой вкладке остаётся memory */ }
}

/** Читаем общий для вкладок код; старое sessionStorage переносим в новый формат. */
export function referralCode(): string {
  for (const read of [() => localStorage.getItem(SAVED_KEY), () => sessionStorage.getItem(KEY)]) {
    try {
      const raw = read()
      if (!raw) continue
      // Маркер очистки не даёт другой вкладке восстановить старый код из sessionStorage.
      if (raw === 'null') {
        memory = null
        try { sessionStorage.removeItem(KEY) } catch { /* хранилище недоступно */ }
        return ''
      }
      if (/^[a-z0-9]{4,32}$/i.test(raw)) { saveReferral(raw); return raw.toLowerCase() }
      const saved: unknown = JSON.parse(raw)
      if (!saved || typeof saved !== 'object' || !('code' in saved) || !('expires' in saved)) continue
      const { code, expires } = saved
      if (typeof code !== 'string' || typeof expires !== 'number' || !parseReferral(code)) continue
      if (expires <= Date.now()) { clearReferral(); return '' }
      memory = { code: parseReferral(code), expires }
      return memory.code
    } catch { /* попробуем следующее хранилище */ }
  }
  return memory && memory.expires > Date.now() ? memory.code : ''
}

/** Забираем код до отрисовки, сохраняя остальные параметры и маршрут регистрации. */
export function catchReferral(): void {
  const url = new URL(window.location.href)
  const code = parseReferral(url.href)
  if (!code) return
  saveReferral(code)
  if (/^\/r\//i.test(url.pathname)) url.pathname = '/'
  url.searchParams.delete('ref')
  window.history.replaceState(null, '', url.pathname + url.search + url.hash)
}
